module.exports = __webpack_public_path__ + "static/img/china.fdac042.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/screen28896/influence-zone/china.png
// module id = U5tX
// module chunks = 1